import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FileInput, TabPanel } from '../../../FlowConfigurationInputs';
import { CodeEditor } from '../../../FlowConfigurationInputs/CodeEditor/CodeEditor';
import { RadioOption, RadioPicker } from '../../../FlowConfigurationInputs/RadioPicker/RadioPicker';
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import { Checkbox, FormControlLabel } from "@material-ui/core";
import VariablePicker from '../../../FlowConfigurationInputs/VariablePicker/VariablePicker';

/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Returns     Component
 * @Author      Abdullah Onur Yeşil
 */
function RunMacro({ action, showAlert, setOpenVariable, variables }) {
    const { t } = useTranslation();
    const [checked, setChecked] = useState(false);
    const [fileType, setFileType] = useState(action.fields.fileType?.value ? action.fields.fileType.value : 'select');
    const [valueType, setValueType] = useState('file');
    const label = 'CONTENT.CONFIGURATION-FORM.EXCEL.RUN-MACRO.';
    const c_label = 'CONTENT.CONFIGURATION-FORM.EXCEL.COPY.';
    const py_label = 'CONTENT.CONFIGURATION-FORM.PYTHON.OPEN.';
    useEffect(() => {
        if (action.fields.queryNewOne?.value) {
            setChecked(true);
            setValueType(action.fields.valueType?.value);
        }
    }, [action]);

    const options = {
        fileInput: {
            checkExtension: (ext) => {
                if (ext !== 'vbs') {
                    showAlert(t(label + 'UPLOAD-PYTHON-ONLY'));
                    return false;
                }
                return true;
            },
            fileType: '.vbs'
        }
    };

    function changeFileType(v) {
        if (v === 'custom') {
            action.fields.text = { type: 'TEXT', isRequired: true };
            delete action.fields.file;
        } else {
            action.fields.file = { type: 'FILE', isRequired: true };
            delete action.fields.text;
        }
        action.fields.fileType = { value: v };
        setFileType(v);
    }

    const changeValueType = (e) => {
        let v = e.target.value;
        action.fields.valueType = { value: v };
        if (v === 'text') {
            action.fields.script = { value: '', isRequired: true };
            delete action.fields.file;
            delete action.fields.text;
        } else {
            changeFileType('select');
            delete action.fields.script;
        }
        setValueType(v);
    };
    function handleOnChange(event) {
        if (!event.target.checked) {
            delete action.fields.file;
            delete action.fields.text;
            delete action.fields.valueType;
            delete action.fields.script;
            delete action.fields.fileType;
        } else {
            action.fields.valueType = { value: 'text' }
            setValueType('text');
            action.fields.script = { isRequired: true }
            delete action.fields.file
            delete action.fields.text
        }
        action.fields.queryNewOne = { value: event.target.checked }
        setChecked(event.target.checked)
    }
    return (
        <div>
            <div className="form-element">
                <div className="form-element">
                    {t(c_label + 'EXCEL-SOURCE')}
                    <VariablePicker action={action} inputName="excelSource" variables={variables}
                        setOpenVariable={setOpenVariable} filter="data table" isRequired />
                    <small><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'data table' })}</em></small>
                </div>
            </div>
            <div className="form-element">
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={checked}
                            onChange={handleOnChange}
                            name="size"
                            color="#C4C4C4"
                            size="small"
                        />
                    }
                    label={t(label + "QUERY-NEW-ONE")}
                />
            </div>
            {checked &&
                <RadioPicker value={valueType} onChange={changeValueType}>
                    <RadioOption value="file">
                        <div className="form-element">
                            {t(py_label + 'FILE-PATH')}
                            <div className="condition-tabs">
                                <button disabled={valueType !== 'file'}
                                    className={fileType === 'select' ? 'condition-active' : ''}
                                    onClick={() => changeFileType('select')}>
                                    {t(py_label + 'SELECT-FILE')}
                                </button>
                                <button disabled={valueType !== 'file'}
                                    className={fileType === 'custom' ? 'condition-active' : ''}
                                    onClick={() => changeFileType('custom')}>
                                    {t(py_label + 'CUSTOM-STRING')}
                                </button>
                            </div>
                            <TabPanel value={fileType} index={'select'}>
                                <FileInput action={action} inputName="file" options={options.fileInput} isRequired={valueType === 'file' && fileType === 'select'} isSize={true} disabled={valueType !== 'file'} />
                            </TabPanel>
                            <TabPanel value={fileType} index={'custom'}>
                                <TextInput action={action} inputName="text" isRequired={valueType === 'file' && fileType === 'custom'} setOpenVariable={setOpenVariable} variables={variables} disabled={valueType !== 'file'} />
                            </TabPanel>
                        </div>
                    </RadioOption>
                    <RadioOption value="text" active={valueType === 'text'}>
                        <div className="form-element">
                            {t(py_label + 'MANUAL')}
                            <CodeEditor action={action} inputName="script" variables={variables} setOpenVariable={setOpenVariable} language="python" multiline disabled={valueType !== 'text'} isRequired={valueType === 'text'} />
                        </div>
                    </RadioOption>
                </RadioPicker>
            }
            <div className="form-element">
                {t(label + 'MACRO-NAME')}
                <TextInput action={action} inputName="macroName" isRequired setOpenVariable={setOpenVariable} variables={variables} />
            </div>
        </div>
    );
}
export default RunMacro;